import { render, staticRenderFns } from "./DuplicateArticleModal.vue?vue&type=template&id=543744be&scoped=true&"
import script from "./DuplicateArticleModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateArticleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543744be",
  null
  
)

export default component.exports